import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select, { components } from "react-select";
import { getCountries } from "../../../../services/CommonServices";
// import { isValidPhoneNumber } from "libphonenumber-js/min";

const CustomMobileWithCountryCode = ({
  fieldName,
  error,
  value,
  label,
  handleBlur,
  classes,
  inputType = "text",
  handleChange,
  setFieldValue,
  country_code,
  countryCodeField,
  setSelectedCountry,
  ...inputProps
}) => {
  const MOBILE_VALIDATION_RULES = {
    "+91": { min: 10, max: 10 },  // India
    "+1": { min: 10, max: 11 },   // USA/Canada
    "+971": { min: 9, max: 9 },   // UAE
    "+44": { min: 10, max: 10 },  // UK
    "+61": { min: 9, max: 9 },    // Australia
    "+81": { min: 10, max: 10 },  // Japan
  };

  // const getValidationLimits = (countryCode, number) => {
  //   if (!countryCode || !number) return false;

  //   // Ensure digits only
  //   if (!/^\d+$/.test(number)) return false;

  //   const phone = `${countryCode}${number}`;
  //   return isValidPhoneNumber(phone);
  // }

  //   const cc = code.startsWith("+") ? code : `+${code}`;
  //   return MOBILE_VALIDATION_RULES[cc] || { min: 6, max: 15 };
  // };


  const dispatch = useDispatch();
  const { data: countries } = useSelector((state) => state.country);
  useEffect(() => {
    dispatch(getCountries());
  }, []);

  const [selected, setSelected] = useState(
    country_code ? country_code.toString() : "+91"
  );
  const [showDropdown, setShowDropdown] = useState(false);
  const [search, setSearch] = useState("");

  // Initialize country_code field value when component mounts or country_code prop changes
  useEffect(() => {
    const initialCountryCode = country_code ? country_code.toString() : "+91";
    if (countryCodeField && setFieldValue) {
      setFieldValue(countryCodeField, initialCountryCode);
      setSelected(initialCountryCode);
    }
  }, [countryCodeField, setFieldValue, country_code]);

  useEffect(() => {
    if (setSelectedCountry) setSelectedCountry(selected);
  }, [selected]);

  const filteredCountries = countries.filter((c) =>
    `${c.name} ${c.phonecode}`.toLowerCase().includes(search.toLowerCase())
  );

  const [highlightedIndex, setHighlightedIndex] = useState(0);

  const containerRef = useRef(null);
  const inputRef = useRef(null);

  const handleKeyDown = (e) => {
    if (!showDropdown) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        prev < filteredCountries.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        prev > 0 ? prev - 1 : filteredCountries.length - 1
      );
    } else if (e.key === "Enter") {
      e.preventDefault();
      const selectedItem = filteredCountries[highlightedIndex];
      if (selectedItem) {
        setSelected(selectedItem.phonecode);
        setFieldValue("countryCode", selectedItem.phonecode);
        handleChange({ target: { name: fieldName, value: "" } });
        setShowDropdown(false);
        setSearch("");
      }
    } else if (e.key === "Escape") {
      e.preventDefault();
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (showDropdown) {
      setHighlightedIndex(0);
      setTimeout(() => inputRef.current?.focus(), 50);
    }
  }, [showDropdown]);

  return (
    <div
      className={`form-group ${classes ? classes : ""} mb-1 ${error ? "is-invalid" : "is-valid"
        }`}
    >
      <label className="text-label">{label}</label>
      <div className="d-flex border rounded position-relative">
        <div ref={containerRef}>
          <div style={{ display: "inline-block" }}>
            {/* Label-like button */}
            <div
              onClick={() => !inputProps.disabled && setShowDropdown(!showDropdown)}
              className="form-control border-0 input d-flex align-items-center"
              style={{
                paddingRight: "0",
                cursor: inputProps.disabled ? "not-allowed" : "pointer",
                backgroundColor: "transparent"
              }}
            >
              {selected && !selected?.startsWith("+")
                ? `+${selected}`
                : selected}
              <div
                style={{
                  alignSelf: "stretch",
                  width: "1px",
                  backgroundColor: "hsl(0, 0%, 80%)",
                  marginBottom: "8px",
                  marginTop: "8px",
                  marginLeft: "10px",
                  boxSizing: "border-box",
                }}
              ></div>
            </div>

            {/* Dropdown container */}
            {showDropdown && (
              <div
                style={{
                  position: "absolute",
                  top: "110%",
                  left: 0,
                  background: "#fff",
                  border: "1px solid #ccc",
                  width: "100%",
                  maxHeight: "200px",
                  overflowY: "auto",
                  zIndex: 1000,
                  // borderRadius: "4px",
                  // boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                }}
              >
                {/* Search input */}
                <input
                  type="text"
                  ref={inputRef}
                  placeholder="Search country or code"
                  value={search}
                  disabled={inputProps.disabled}
                  autoFocus={showDropdown}
                  // onKeyDown={(e) => {
                  //   if (e.key === "Enter") {
                  //     e.preventDefault();
                  //     const selectedItem = filteredCountries[highlightedIndex];
                  //     if (selectedItem) {
                  //       setSelected(selectedItem.phonecode);
                  //       setShowDropdown(false);
                  //       setSearch("");
                  //     }
                  //   }
                  // }}
                  onKeyDown={handleKeyDown}
                  // onBlur={() => setShowDropdown(false)}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "6px 8px",
                    boxSizing: "border-box",
                    position: "sticky",
                    top: 0,
                    // borderBottom: "1px solid #eee",
                  }}
                />

                {/* Country list */}
                {filteredCountries.map((country, index) => (
                  <div
                    key={country.phonecode}
                    onClick={() => {
                      setSelected(country.phonecode);
                      handleChange({ target: { name: fieldName, value: "" } });
                      setFieldValue(
                        countryCodeField ?? "countryCode",
                        country.phonecode
                      );
                      setShowDropdown(false);
                      setSearch("");
                    }}
                    style={{
                      padding: "8px 10px",
                      cursor: "pointer",
                      fontSize: "14px",
                      color:
                        index === highlightedIndex
                          ? "#fff"
                          : "var(--bs-card-color)",
                      backgroundColor:
                        index === highlightedIndex
                          ? "var(--abhi-secondary)"
                          : "#fff",
                      zIndex: 99999,
                    }}
                  >
                    {country.name} ({country.phonecode})
                  </div>
                ))}

                {filteredCountries.length === 0 && (
                  <div style={{ padding: "8px 10px", color: "#888" }}>
                    No match
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <input
          type="tel"
          className=" border-0 rounded"
          placeholder="Mobile"
          value={value ?? ""}
          disabled={inputProps.disabled}
          onChange={(e) => {
            if (e.target.value == "") {
              handleChange(e);
            } else if (/^[0-9]+$/.test(e.target.value)) {
              // const isValid = getValidationLimits(selected, e.target.value);
              // if (isValid) {
              //   handleChange(e);
              // }
              // const limits = getValidationLimits(selected);

              // if (e.target.value.length <= limits.max) {
              handleChange(e);
              // }
            }
          }}
          onBlur={handleBlur}
          style={{
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            padding: "5px 12px",
            width: "100%",
            backgroundColor: "transparent"
          }}
          {...inputProps}
        />
      </div>
      {error ? (
        <div
          id="val-mobile-error"
          class="invalid-feedback animated fadeInUp"
          style={{ display: "block" }}
        >
          {error}
        </div>
      ) : null}
    </div>
  );
};

export default CustomMobileWithCountryCode;
